import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Card, FlexItem, ListItem, Text } from 'components/Library'
import { colors } from 'components/Library/theme'

const ViewsPerCity = () => {
  const { globalAnalytics } = useSelector((state) => state.analytics)
  const [datosGrafico, setDatosGrafico] = useState([])

  useEffect(() => {
    if (globalAnalytics[3] && globalAnalytics[3].rowCount > 0) {
      const datos = []
      globalAnalytics[3].rows.forEach((analytic) => {
        // Obtener los valores de la iteración actual
        const ciudad = analytic.dimensionValues[0].value // city
        const valor = analytic.metricValues[0].value // screenPageViews
        datos.push({
          ciudad: ciudad === '(not set)' ? 'Otro' : ciudad,
          valor: parseInt(valor)
        })
      })
      datos.sort((a, b) => a.valor + b.valor)

      setDatosGrafico(datos)
    }
  }, [globalAnalytics])

  return (
    <Card
      style={{
        padding: '2rem',
        width: '100%',
        maxHeight: '600px',
        overflowY: 'auto'
      }}
    >
      <Text weight="bold">Visitas por ciudades</Text>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          placeItems: 'center',
          padding: '1rem 0',
          textAlign: 'center'
        }}
      >
        <svg
          stroke="currentColor"
          fill={colors.secondary}
          strokeWidth={0}
          viewBox="0 0 24 24"
          height="4em"
          width="4em"
        >
          <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
        </svg>
        <Text color={colors.secondary} size="extralarge" weight="bold">
          {datosGrafico[0]?.valor}
        </Text>
        <Text color={colors.secondary} weight="bold" size="large">
          {datosGrafico[0]?.ciudad}
        </Text>
      </div>
      {datosGrafico.map((ciudad, index) => (
        <ListItem
          key={index}
          style={{
            display: 'flex',
            gridGap: '1rem',
            paddingTop: '1rem'
          }}
        >
          <FlexItem
            alignItems="center"
            flexDirection="row"
            style={{
              padding: '0',
              flex: 'auto'
            }}
          >
            <FlexItem
              flexDirection="column"
              style={{
                padding: 0,
                placeItems: 'flex-start'
              }}
            >
              <Text>{ciudad?.ciudad}</Text>
            </FlexItem>
            <Text size="large" weight="bold">
              {ciudad?.valor}
            </Text>
          </FlexItem>
        </ListItem>
      ))}
    </Card>
  )
}

export default ViewsPerCity
